import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { enumEntrySummaryDutiesPaymentType } from '@data-layer/enums/entry-summaries';
import { CompaniesService } from '@services/companies.service';

@Component({
  selector: 'es-shipment-duties-payment-form-desktop',
  template: `
    <p class="mb-0">{{ 'LABELS.CHOOSE_TYPE_OF_DUTIES_ES' | translate }}</p>
    <p class="text-hint">{{ 'LABELS.CHOOSE_TYPE_OF_DUTIES_ES_HINT' | translate }}</p>

    <form [formGroup]="formGroup" autocomplete="off">
      <div class="d-flex justify-content-between shipment-duties-types">
        <div
          class="card card-step shipment-duties-type"
          [ngClass]="{ 'is-selected': typeControl.value === enumEntrySummaryDutiesPaymentType.ACH }"
        >
          <div class="card-header">
            <app-radio-button
              [control]="typeControl"
              [id]="isSidebar ? 'sidebar-duties-type-ach' : 'duties-type-ach'"
              [label]="'DUTIES_PAYMENT_TYPE.ACH'"
              [value]="enumEntrySummaryDutiesPaymentType.ACH"
              [name]="'shipment-duties-type'"
            ></app-radio-button>
          </div>
        </div>
        <div
          class="card card-step shipment-duties-type"
          [ngClass]="{ 'is-selected': typeControl.value === enumEntrySummaryDutiesPaymentType.INSTANT }"
        >
          <div class="card-header">
            <app-radio-button
              [control]="typeControl"
              [id]="isSidebar ? 'sidebar-duties-type-paypal' : 'duties-type-paypal'"
              [label]="'DUTIES_PAYMENT_TYPE.INSTANT'"
              [value]="enumEntrySummaryDutiesPaymentType.INSTANT"
              [name]="'shipment-duties-type'"
            ></app-radio-button>
          </div>
        </div>
      </div>
    </form>
  `,
  styleUrls: ['./es-shipment-duties-payment-form-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsShipmentDutiesPaymentFormDesktopComponent implements OnInit, OnDestroy {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isSidebar: boolean;
  @Input() public isACHDisabled: boolean;

  public typeControl: UntypedFormControl;

  public enumEntrySummaryDutiesPaymentType: typeof enumEntrySummaryDutiesPaymentType = enumEntrySummaryDutiesPaymentType;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private companiesService: CompaniesService) {}

  public ngOnInit(): void {
    this.typeControl = this.formGroup.get('dutiesPaymentType') as UntypedFormControl;

    if (
      (!this.companiesService.getCompany().authorizationAgreementAccepted || !this.companiesService.getCompany().payerUnitNumber) &&
      this.entrySummary?.dutiesPaymentType === enumEntrySummaryDutiesPaymentType.INSTANT
    ) {
      this.formGroup.get('dutiesPaymentType').disable();
      this.formGroup.get('payerUnitNumber').disable();
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
